export default "__VITE_ASSET__DZGTEEjc__"